import { render, staticRenderFns } from "./importstaffs.vue?vue&type=template&id=73c46070&"
import script from "./importstaffs.vue?vue&type=script&lang=js&"
export * from "./importstaffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports